<template>
  <div
    class="auth-page w-100 position-absolute bg-auth login-welcome"
    :style="{ backgroundImage: bgImage }"
  >
    <b-container class="p-0" fluid>
      <b-row align-h="center" class="h-100 no-gutters pt-2 pt-md-5 text-center">
        <b-col cols="12" sm="12" md="12" lg="12" class="px-3">
          <b-container>
            <b-row class="py-4">
              <b-col>
                <router-link to="/">
                  <img
                    :src="logo"
                    height="35"
                    class="mt-4"
                    alt="Realvest Logo"
                  />
                </router-link>
              </b-col>
            </b-row>
          </b-container>
          <div class="form-wrapper p-4 mx-auto bg-auth-white">
            <div class="heading-wrapper pt-1 pb-1 text-center">
              <h4 class="heading font-weight-bold text-black-50">
                Reset Password
              </h4>
              <p class="text-muted">Enter your new password</p>
            </div>
            <b-form @submit="submit" @input="formInput" class="text-left">
              <b-form-group
                :invalid-feedback="formErrors.newpassword"
                :state="fieldState.newpassword"
              >
                <b-form-input
                  id="newpassword"
                  v-model="form.newpassword"
                  type="password"
                  required
                  placeholder="Enter new password"
                  :state="fieldState.newpassword"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                :invalid-feedback="formErrors.newpasswordconfirm"
                :state="fieldState.newpasswordconfirm"
              >
                <b-form-input
                  id="newpasswordconfirm"
                  v-model="form.newpasswordconfirm"
                  type="password"
                  required
                  placeholder="Enter new password again"
                  :state="fieldState.newpasswordconfirm"
                ></b-form-input>
              </b-form-group>

              <StatefulButton
                :error="error"
                :loading="submitting"
                text="Submit"
                loadingText="Submitting..."
                elementClass="w-100 mb-3"
              />
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { AuthService } from "@/services";
import StatefulButton from "@/components/actions/StatefulButton.vue";
import {
  validateRequired,
  validatePassword,
  checkFormErrors
} from "@/utils/validators";

export default {
  name: "reset-password-with-token",
  components: {
    StatefulButton
  },
  data() {
    return {
      logo: require("@/assets/icons/logo-dark.svg"),
      bgImage: `url(${require("@/assets/images/greatest-realvest.jpg")})`,

      form: {
        newpassword: "",
        newpasswordconfirm: ""
      },
      formErrors: {},
      submitting: false,
      error: false
    };
  },
  computed: {
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },
  async created() {
    await this.logout({ reRoute: false });
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();
        const { message } = await AuthService.resetPassword({
          ...this.form,
          token: this.$route.params.token
        });
        this.$store.dispatch("toast", {
          message
        });
        this.$router.replace({ name: "login" });
      } catch (err) {
        this.formErrors = err;
        this.error = true;
      } finally {
        this.submitting = false;
      }
    },
    validateForm() {
      const { newpassword, newpasswordconfirm } = this.form;
      let { errors, valid } = validateRequired({
        newpassword,
        newpasswordconfirm
      });

      if (!errors.newpassword) {
        const res = validatePassword(newpassword);
        errors.newpassword = res.errors.newpassword;
        valid = valid && res.valid;

        if(res.valid === false) {
          errors.newpasswordconfirm = res.errors.password;
          valid = false;
        }
      }

      if(newpassword !== newpasswordconfirm) {
        errors.newpasswordconfirm = "Passwords must match";
        valid = false;
      }

      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    }
  }
};
</script>

<style lang="scss" scoped>
.form-wrapper {
  height: fit-content;
  overflow: hidden;
  border-radius: 4px;
  max-width: 400px;
  box-shadow: 1px 0px 20px rgba(0, 0, 0, 0.08);
}

.login-welcome {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--secondary);
    opacity: 0.6;
    width: 100%;
    height: 100%;
  }
}
</style>
